import React, { useEffect } from "react";
import classes from "./Drawer.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaXmark,
  FaTrophy,
  FaChartSimple,
  FaUser,
  FaGamepad,
  FaGear,
  FaPowerOff,
  FaArrowRightFromBracket,
} from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { setUnsubModal } from "../store/slices/unsubModalSlice";
import { removeUser } from "../store/slices/userSlice";

const Drawer = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  const handleNavigate = (path) => {
    navigate(path);
    setOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    dispatch(removeUser());
    navigate("/");
  };

  return (
    <>
      <div
        className={`${classes.backdrop} ${open ? classes.backdropShow : ""}`}
        onClick={() => setOpen(false)}
      />

      <aside className={`${classes.drawer} ${open ? classes.drawerOpen : ""}`}>
        <div className={classes.drawerHeader}>
          <div className={classes.brandWrap}>
            <img
              src="/images/logo2.png"
              alt="UV Gaming"
              className={classes.logo}
            />
            <p className={classes.brandSub}>Powered by Vodacom</p>
          </div>

          <button
            type="button"
            className={classes.closeBtn}
            onClick={() => setOpen(false)}
          >
            <FaXmark />
          </button>
        </div>

        <div className={classes.links}>
          <button
            className={`${classes.linkBtn} ${isActive("/winners") ? classes.activeLink : ""
              }`}
            onClick={() => handleNavigate("/winners")}
          >
            <span className={classes.linkIcon}>
              <FaTrophy />
            </span>
            <span>{t("55")}</span>
          </button>

          <button
            className={`${classes.linkBtn} ${isActive("/leaderboard") ? classes.activeLink : ""
              }`}
            onClick={() => handleNavigate("/leaderboard")}
          >
            <span className={classes.linkIcon}>
              <FaChartSimple />
            </span>
            <span>{t("56")}</span>
          </button>

          <button
            className={`${classes.linkBtn} ${isActive("/profile") ? classes.activeLink : ""
              }`}
            onClick={() => handleNavigate("/profile")}
          >
            <span className={classes.linkIcon}>
              <FaUser />
            </span>
            <span>{t("57")}</span>
          </button>

          <button
            className={`${classes.linkBtn} ${isActive("/my-games") ? classes.activeLink : ""
              }`}
            onClick={() => handleNavigate("/my-games")}
          >
            <span className={classes.linkIcon}>
              <FaGamepad />
            </span>
            <span>{t("127")}</span>
          </button>


          <button
            className={`${classes.linkBtn} ${isActive("/settings") ? classes.activeLink : ""
              }`}
            onClick={() => handleNavigate("/settings")}
          >
            <span className={classes.linkIcon}>
              <FaGear />
            </span>
            <span>{t("128")}</span>
          </button>

          <button
              className={`${classes.linkBtn}`}
            onClick={() => handleLogout()}
          >
            <span className={classes.linkIcon}>
              <FaArrowRightFromBracket />
            </span>
            <span>{t("106")}</span>
          </button>

          <button
            className={classes.unsub_button}
            onClick={() => {
              setOpen(false);
              dispatch(setUnsubModal(true))
            }}
          >
            <span className={classes.linkIcon}>
              <FaXmark />
            </span>
            <span>{t("129")}</span>
          </button>

        </div>
      </aside>
    </>
  );
};

export default Drawer;